import { cn } from "@client/lib/cn";

interface UserAvatarProps {
  name: string | null;
  email: string;
  avatarUrl: string | null;
  className?: string;
}

function initialsOf(name: string | null, email: string): string {
  const source = name?.trim() || email;
  const parts = source.split(/\s+/).filter(Boolean);
  const initials = parts.length > 1 ? `${parts[0]?.[0] ?? ""}${parts[1]?.[0] ?? ""}` : source.slice(0, 2);
  return initials.toUpperCase();
}

export function UserAvatar({ name, email, avatarUrl, className }: UserAvatarProps) {
  const base = cn("size-8 shrink-0 rounded-full border border-border-hover", className);
  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt=""
        width={32}
        height={32}
        referrerPolicy="no-referrer"
        className={cn(base, "object-cover")}
      />
    );
  }
  return (
    <span
      aria-hidden="true"
      className={cn(base, "flex items-center justify-center bg-accent-soft text-xs font-medium text-foreground")}
    >
      {initialsOf(name, email)}
    </span>
  );
}
